module.exports = __webpack_public_path__ + "img/heating-system.146302cd.svg";